var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-pic-rows-root"},_vm._l((_vm.$config.HomePics),function(item){return _c('HomePic',{key:item.name,attrs:{"image":item.pic,"fillColor":item.fillColor}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }